/* eslint-disable */

/**
 * This script should be added to direct partner pages
 * with a script tag like this.

   <script defer
    src="https://dabu.askmediagroup.com/s/v1.0.5/initiator.min.js"
    id="amg_dabu_init"

    data-dabu-placement-id="amg_dabu_target"
    data-dabu-campaign-id="amg_rr"
    data-dabu-width=300
    data-dabu-height=250
    ></script>

    adjustable params:
      data-dabu-placement-id - comma-separated list of ids of the divs to mount the sib to
      data-dabu-width - The width of the ad slot
      data-dabu-height - The height of the ad slot
      data-dabu-campaign-id - an identifier given to you by AMG. Identifies a campaign.

      (internal notes, don't share with pubs)
      data-dabu-creative-id - (legacy) This value will be appended to the value of window.location.host
      with an underscore separating the two and used as the `campaign_id`.
        ex: if `data-dabu-creative-id` is `1` and the script is included on the site `https://moneywise.com/a/ch-b/10-mindless-wastes-of-money`
        then the campaign_id on the configuration sheet would be `moneywise.com_1`
 */

import AmgAds from '../src/AmgAds';

(function() {
  // assigns self to window
  window.amgAds = window.amgAds || {};
  const instance = new AmgAds(document, window);
  const timeout = instance.dataset.timeout;
  window.amgAds[instance.dataset.adType] = instance;
  window.setTimeout(instance.initializeAds.bind(instance), Number(timeout));
})();
